import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

export const incrementSendOfferTotal = () =>
  clientSideMetrics.counter('web_send_offer_total').increment()

export const incrementSendOfferFailureTotal = () =>
  clientSideMetrics.counter('web_send_offer_failure_total').increment()
